module.exports = __webpack_public_path__ + "static/media/skip_button@3x.08b95ff8.png";